import { FC } from 'react';
import { Badge, Item, ItemDescription, ItemHeader, ItemTitle } from '@ibsys/kit';
import { TruncatedText } from '@/shared/ui';
import { AttributeResponse } from '@/entities/attributes';
import { IsActiveBadge } from '@/features/IsActiveBadge';
import { cn, useAppNavigate } from '@/shared/lib';
import { useGetAttributeTypes } from '@/pages/attributes/utils';
import { useSearchParams } from 'react-router-dom';

type Props = {
  attribute: AttributeResponse;
  className?: string;
  isActive?: boolean;
};

export const AttributeCard: FC<Props> = ({ className, attribute, isActive }) => {
  const { getLabelByType } = useGetAttributeTypes();
  const [searchParams] = useSearchParams();
  const navigate = useAppNavigate();

  const handleSelect = () => {
    navigate(`/attributes/:id?/:parentStruct?/?${searchParams.toString()}`, {
      parentStruct: attribute.parentStructCode || null,
      id: attribute.code,
    });
  };

  return (
    <Item
      variant={isActive ? 'muted' : 'outline'}
      className={cn('hover:bg-accent', isActive && 'bg-accent text-accent-foreground', className)}
      onClick={handleSelect}
    >
      <ItemHeader className={'w-full'}>
        <ItemTitle className={'flex flex-col text-left items-start w-full'}>
          <p>{attribute.name}</p>
          <TruncatedText className="font-mono text-xs font-medium text-muted-foreground w-full">{`${attribute.code}`}</TruncatedText>
        </ItemTitle>
      </ItemHeader>
      <ItemDescription className="flex gap-1">
        <Badge className="text-xs font-light" outline>
          {getLabelByType(attribute.dataType)}
        </Badge>
        <IsActiveBadge isActive={!attribute.isDeleted} />
      </ItemDescription>
    </Item>
  );
};
